import { html, nothing } from 'lit';
import { BoilerplateModal } from './boilerplate_modal';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

class ModalWishlistAddNotification extends BoilerplateModal {
  constructor() {
    super();
    this.fromBottom = true;
  }

  updated(changedAttributes) {
    if (changedAttributes.has('detail')) {
      const addedAmount = this.detail?.addedAmount;
      const totalAmount = this.detail?.totalAmount;
      this.title = window.theme.strings.wishlist.add_notification_title
        .replace('{{ added_amount }}', addedAmount)
        .replace('{{ total_amount }}', totalAmount);
    }
  }

  renderBody() {
    if (!this.detail) {
      return nothing;
    }

    return html` <div class="text_content">${unsafeHTML(window.theme.strings.wishlist.add_notification_message)}</div> `;
  }
}

window.customElements.get('modal-wishlist-add-notification') || window.customElements.define('modal-wishlist-add-notification', ModalWishlistAddNotification);
